<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.tab.logistique')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="$t('societes.typeOtAudit')">
                <b-select v-model="societe.typeOtAuditId" expanded>
                  <option :key="null" :value="null"></option>
                  <option v-for="type in typesOT"
                        :key="type.id"
                        :value="type.id">
                    {{ type.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6" v-if="moduleStockTiersActive">
              <b-field :label="$t('societes.typeOtImpression')">
                <b-select v-model="societe.typeOtImpressionId" expanded>
                  <option :key="null" :value="null"></option>
                  <option v-for="type in typesOTImpression"
                        :key="type.id"
                        :value="type.id">
                    {{ type.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    typesOTImpression() {
      return this.typesOT.filter(type => type.actionInterventionOt === IMPRESSION_AFFICHE);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },

};
</script>
